import script from "./invoice-enterprise-dialog-info.vue?vue&type=script&lang=tsx&setup=true"
export * from "./invoice-enterprise-dialog-info.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__